import { Dialog } from "radix-ui";
import DialogHeader from "./DialogHeader";
import DialogFooter from "./DialogFooter";
import { SuccessIcon } from "../../atoms/images/SuccessIcon";
import { ErrorIcon } from "../../atoms/images/ErrorIcon";
import DialogTitle from "../../atoms/dialog/DialogTitle";
import DialogDescription from "../../atoms/dialog/DialogDescription";
import { useTranslation } from "react-i18next";

export default function DialogContent({
  title,
  message,
  buttonLabel = "",
  showIcon = true,
  secondaryButtonLabel = "",
  iconType,
  onModalSubmit,
}) {
  const { t, i18n } = useTranslation();
  return (
    <>
      <DialogHeader showClose />

      <div className="block text-center">
        {showIcon && (
          <div className="flex flex-col items-center text-center">
            {iconType === "success" ? (
              <SuccessIcon />
            ) : iconType === "error" ? (
              <ErrorIcon />
            ) : null}
          </div>
        )}
        <DialogTitle title={title} />
        <DialogDescription message={message} />
        <DialogFooter
          label={buttonLabel}
          secondaryLabel={secondaryButtonLabel}
          onModalSubmit={onModalSubmit}
        />
      </div>
    </>
  );
}
